var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckedicon = function SvgCheckedicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm11.056-2.808a.4.4 0 0 0-.56 0L6.704 8.984l-1.2-1.192a.384.384 0 0 0-.56 0l-.424.424a.4.4 0 0 0 0 .568L6.4 10.68a.384.384 0 0 0 .56 0l4.496-4.496a.4.4 0 0 0 0-.568l-.4-.424Z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckedicon;